import {
  CountryKoodistoCode,
  getCountryCodeByShortName,
  VtjCountryCodeAdditions,
} from 'todistukset-common/src/vtj/vtj-koodisto.util'
import {
  getAllCountries,
  getValtioKoodistoEntryByCode,
} from 'todistukset-common/src/vtj/country.util'
import {
  finalEditableFieldValue,
  FlattenedEditableField,
  isEditableField,
  Kayttoalue,
} from 'todistukset-common/src/vtj/types/editable-field.type'

export const getUsageRegionFromCode = (
  countryCode: CountryKoodistoCode | null
): string => {
  const usageRegion = getValtioKoodistoEntryByCode(countryCode)
    ?.en?.toUpperCase()
    .replace(/ /g, '_')
  if (!usageRegion) {
    throw new Error(`usageRegion not found for country code '${countryCode}'`)
  }

  return usageRegion
}

export const getCodeFromUsageRegion = (
  usageRegion: Kayttoalue | FlattenedEditableField<Kayttoalue> | null
): CountryKoodistoCode | null => {
  const usageRegionValue = isEditableField(usageRegion)
    ? finalEditableFieldValue(usageRegion)
    : usageRegion

  if (!usageRegionValue) {
    return null
  }

  return getCountryCodeByShortName(usageRegionValue.replace(/_/g, ' '))
}

export const availableUsageRegions = getAllCountries(false)
  .filter(
    ({ koodistoCode }) =>
      !Object.values(VtjCountryCodeAdditions).some(
        (code) => code === koodistoCode
      )
  )
  .map(({ koodistoCode }) => getUsageRegionFromCode(koodistoCode))
